// store/modules/driver.js
const state = {
  driverInstance: null,
};

const mutations = {
  SET_DRIVER_INSTANCE(state, instance) {
    state.driverInstance = instance;
  },
  CLEAR_DRIVER_INSTANCE(state) {
    state.driverInstance = null;
  },
};

const actions = {
  setDriverInstance({ commit }, instance) {
    console.log('Vuex: Setting driver instance:', instance);
    commit('SET_DRIVER_INSTANCE', instance);
  },
  
  destroyDriverInstance({ commit, state }) {
    console.log('Vuex: Destroying driver instance');
    if (state.driverInstance) {
      console.log('Vuex: Driver instance found, calling destroy()');
      try {
        state.driverInstance.destroy();
        console.log('Vuex: Driver instance destroyed successfully');
      } catch (error) {
        console.error('Vuex: Error destroying driver instance:', error);
      }
      commit('CLEAR_DRIVER_INSTANCE');
    } else {
      console.log('Vuex: No driver instance found to destroy');
    }
  },
  
  clearDriverInstance({ commit }) {
    console.log('Vuex: Clearing driver instance');
    commit('CLEAR_DRIVER_INSTANCE');
  },
};

const getters = {
  driverInstance: (state) => state.driverInstance,
  hasDriverInstance: (state) => !!state.driverInstance,
};

export default {
  namespaced: true,
  state,
  mutations,
  actions,
  getters,
};